module.exports = __webpack_public_path__ + "img/Wp_2043.19a7d4ba.png";